"use client";

const VISITOR_COOKIE = "visitor_id";
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year in seconds

export function getOrCreateVisitorId(): string {
  if (typeof document === "undefined") return "";

  const existing = document.cookie
    .split("; ")
    .find((c) => c.startsWith(`${VISITOR_COOKIE}=`))
    ?.split("=")[1];

  if (existing) return existing;

  const id = crypto.randomUUID();
  document.cookie = `${VISITOR_COOKIE}=${id}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  return id;
}
